// extracted by mini-css-extract-plugin
export default {"root":"SessionInventoryContent_root__UB1ip","sidebar":"SessionInventoryContent_sidebar__DXg3A","content":"SessionInventoryContent_content__sUZpr"};